import { Action, createReducer, on } from '@ngrx/store';

import { NavigationItem } from '@app/entities/router-state.entity';
import { HeaderPageType } from '@header/entities/ds-header-config';
import { homeRootRoute } from '@home/home-routing.module';
import {
  addNavigationItemAction, removeLastNavigationItemAction, resetNavigationAction
} from '@app/store/actions/global.actions';
import {
  setPackageBaseUrlResultInHotelDetailAction, setHotelResultUrlInHotelDetailAction
} from '@hotels/hotel-detail/store/actions/hotels.actions';
import { hotelResultsRootRoute } from '@hotels/hotel-results/hotel-results-routing.module';
import { setHotelResultURL } from '@hotels/hotel-detail/mappers/url-results.mapper';
import { packagesResultRootRoute, STEP_SECTION } from '@packages/packages-result/constants/packages-result.routes';
import { PackageStep } from '@packages/packages-search-bar/constants/package-step';

export const DefaultNavigationState: NavigationItem[] = [{
  Url: homeRootRoute,
  PageType: HeaderPageType.HomePage,
  Extras: {}
}];

export const initialState: NavigationItem[] = DefaultNavigationState;

const featureReducer = createReducer(
  initialState,
  on(addNavigationItemAction, (state, { item }) => {
    const _state = state || initialState;
    return addOrReplaceItem(_state, item);
  }),
  on(setPackageBaseUrlResultInHotelDetailAction, (state, { url }) => {
    if (state.length && state.find(item => item.Url?.includes(packagesResultRootRoute))) {
      const pos = state.findIndex(item => item.Url?.includes(packagesResultRootRoute));
      const newUrl = url.replace(STEP_SECTION, PackageStep.HOTEL_RESULTS);
      return [...state.slice(0, pos), { ...state[pos], Url: newUrl }, ...state.slice(pos + 1)];
    } else {
      return state;
    }
  }),
  on(setHotelResultUrlInHotelDetailAction, (state, { url }) => {
    if (state.find(item => item.Url?.includes(hotelResultsRootRoute) && item.PageType === HeaderPageType.ResultsPage)) {
      const pos = state.findIndex(item => item.Url?.includes(hotelResultsRootRoute));
      const newUrl = setHotelResultURL(state[pos].Url, url);
      return newUrl ? [...state.slice(0, pos), { ...state[pos], Url: newUrl }, ...state.slice(pos + 1)] : state
    } else {
      return state;
    }
  }),
  on(removeLastNavigationItemAction, (state) => {
    return state.length === 1 ? state : state.slice(0, -1);
  }),
  on(resetNavigationAction, () => initialState),
);

export const navigationReducer = (state: NavigationItem[], action: Action): NavigationItem[] => {
  return featureReducer(state, action);
};

function addOrReplaceItem(_state: NavigationItem[], item: NavigationItem): NavigationItem[] {
  let state = _state;
  if (item.PageType) {
    if (state?.find(s => s.PageType === item?.PageType)) {
      state = state.slice(0, state.findIndex(s => s.PageType === item.PageType) + 1);      
    }
    const lastAdded = state?.at(-1);
    const newStateByAdd = !state.find(nav => nav.Url === item.Url && nav.PageType === item.PageType) ? [...state, item] : state;
    if (lastAdded?.PageType === item?.PageType) {
      const itemParams = item?.Url?.split('/').filter(param => !!param);
      const lastAddedParams = lastAdded?.Url?.split('/').filter(param => !!param);
      const newStateByReplace = !item.Url.includes(lastAdded?.Url) ? [...(state?.slice(0, state?.length - 1)), item] : state;
      const diff = (a: number, b: number) => (a > b) ? (a - b) : (b - a);
      if (item.PageType === HeaderPageType.ResultsPage) {
        if (itemParams?.length === lastAddedParams?.length) {
          return newStateByReplace;
        } else {
          return diff(itemParams?.length, lastAddedParams?.length) === 2 ? newStateByAdd : state;
        }
      } else {
        return newStateByReplace;
      }
    } else {
      return newStateByAdd;
    }
  } else {
    return state;
  }
}
